import React from "react";
import { useAuth } from "../lib/auth";
import { Flame } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/* Compact streak indicator for the top bar (desktop + mobile), replacing
   the "Streak" stat tile that used to sit on the home page itself. Purely
   a display — not a link/button — it just counts the streak, nothing to
   click through to. */
export default function StreakBadge() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const streak = user?.streak ?? 0;
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-1.5 rounded-lg border border-sand-300 text-sm font-medium text-terracotta-600"
      title={t("streakBadge.dayStreak", { streak })}
      data-testid="streak-badge"
    >
      <Flame className="h-4 w-4" />
      {streak}
    </span>
  );
}
